const initialTransactionsState = {
    transactionsA: [],
    processedTransactions: [],
    transactionsLoaded: false,
    sumInvested: 0,
    sumDonated: 0,
    sumPending: 0,
    filterSet: false,
    categoryList: {},
    transactionsFilter: {
        searchText: -1,
        categoryFilter: -1,
        dateFilterStart: -1,
        dateFilterEnd: -1,
        valueFilterLow: -1,
        valueFilterHigh: -1
    }
}

const transactionsReducer = (state = initialTransactionsState, action) => {
    switch (action.type) {
        case 'LOAD_TRANSACTIONS':
            return Object.assign({}, state, {
                transactionsA: action.transactions,
                transactionsLoaded: true
            })
        case 'PROCESS_TRANSACTIONS':
            return Object.assign({}, state, {
                processedTransactions: action.transactions,
                sumInvested: action.invested,
                sumDonated: action.donated,
                sumPending: action.sumPending,
                categoryList: action.categoryList
            })
        case 'SET_TRANSACTION_FILTER':
            return Object.assign({}, state, {
                transactionsFilter: action.transactionsFilter,
                filterSet: true
            })
        case 'UNLOAD_TRANSACTIONS':
            return Object.assign({}, state, initialTransactionsState)
        default:
            return state
    }
}

export default transactionsReducer;